"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusGetter = void 0;
function isUndefinedOrNull(value) {
    return value === undefined || value === null;
}
function statusGetter(self, selfConstructor, statusConstructor) {
    for (const key in statusConstructor) {
        // go thru all statuses
        if (isNaN(Number(key))) {
            // get how this status should look like
            const statusPrototype = selfConstructor.statusPrototype(statusConstructor[key]);
            // check if the status props are equal
            let isEqual = true;
            for (const k in statusPrototype) {
                if (isEqual && isUndefinedOrNull(self[k]) != isUndefinedOrNull(statusPrototype[k])) {
                    isEqual = false;
                }
            }
            if (isEqual) {
                return statusConstructor[key];
            }
        }
    }
    throw new Error("status was not recognized");
}
exports.statusGetter = statusGetter;
//# sourceMappingURL=statusGetter.js.map